import * as React from "react";
import { TTranslate } from "../../../../../service/locale/TranslationService";   
import { FormComponentProps } from "antd/lib/form";
import SimpleForm from "./SimpleForm";
import { IFormItem } from "../../../../../model/editform/FormItem";

export interface State {};

export interface CreateUpdateEditFormProps extends FormComponentProps {
    translate: TTranslate;
    registerFormSubmitEventHandler: any;
    formItems: IFormItem[];
    rowData?: any;
    onSubmit: any;
    onCancel: any;
}

class EditForm extends React.Component <
    CreateUpdateEditFormProps,
    State
> {
    componentDidMount() {
        const { registerFormSubmitEventHandler, form, onSubmit, onCancel } = this.props;

        registerFormSubmitEventHandler(e => {
            e.preventDefault(); 

            let newData = null;
            form.validateFields((err, values) => {
                newData = err ? newData : values;
            });

            if (newData) {
                onSubmit(newData);
                onCancel();
            }
        });
    }

    render() {
        const { translate } = this.props;

        const { formItems } = this.props;

        const { rowData } = this.props;

        const { getFieldDecorator } = this.props.form;

        return (
            <SimpleForm
                getFieldDecorator={getFieldDecorator}
                translate={translate}
                rowData={rowData}
                formItems={formItems}
            />
        )
    }
}

export default EditForm;

